import API from "Config/API";

// Every call the delivery-partner directory makes, in one place.
//
// Paths only — Config/API owns the host and attaches the admin identity
// headers the backend writes onto audit rows.

/**
 * Drop empty values so `?verified=` never reaches the server as a filter for
 * the empty string. The backend's tri-state reader ignores it either way, but
 * a request URL that lists every cleared dropdown is unreadable in a log.
 */
export const qs = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      search.append(key, value);
    }
  });
  return search;
};

export const listPartners = (params) =>
  API.get(`/admin/delivery/list?${qs(params)}`).then((r) => r.data);

export const listSummary = (params) =>
  API.get(`/admin/delivery/list/summary?${qs(params)}`).then((r) => r.data);

export const listMapPins = (params) =>
  API.get(`/admin/delivery/list/map?${qs(params)}`).then((r) => r.data);

/**
 * The export is a browser download rather than an axios call: it comes back
 * as text/csv with a Content-Disposition, and there is nothing for React to
 * do with the bytes except hand them to the user.
 */
export const exportUrl = (params) => {
  const base = API.defaults.baseURL?.replace(/\/$/, "") || "";
  return `${base}/admin/delivery/list/export?${qs(params)}`;
};

export const setVerification = (id, verified, reason) =>
  API.patch(`/admin/delivery/${encodeURIComponent(id)}/verification`, {
    verified,
    reason,
  }).then((r) => r.data);

export const setTakingOrders = (id, isTakingOrders, reason) =>
  API.patch(`/admin/delivery/${encodeURIComponent(id)}/taking-orders`, {
    isTakingOrders,
    reason,
  }).then((r) => r.data);

export const forceOffline = (id, reason) =>
  API.post(`/admin/delivery/${encodeURIComponent(id)}/force-offline`, {
    reason,
  }).then((r) => r.data);

export const updateProfile = (id, body) =>
  API.patch(`/admin/delivery/${encodeURIComponent(id)}/profile`, body).then(
    (r) => r.data
  );

export const deletePartner = (id, reason, force) =>
  API.post(`/admin/delivery/${encodeURIComponent(id)}/delete`, {
    reason,
    force,
  }).then((r) => r.data);

export const bulkUpdate = (partnerIds, action, reason) =>
  API.post("/admin/delivery/bulk", { partnerIds, action, reason }).then(
    (r) => r.data
  );
